// member-portal/src/axiosConfig.js

import axios from 'axios';

const setupAxiosInterceptors = (onSessionExpired) => {
  axios.interceptors.response.use(
    response => response,
    error => {
      // Only trigger session expired on 401 for member routes
      if (error.response?.status === 401) {
        const url = error.config?.url || '';
        // Don't trigger on superadmin billing routes — they have their own auth
        if (!url.includes('/api/superadmin/billing')) {
          onSessionExpired();
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;